import { AllIcon } from '@mm/icons';
import classNames from 'classnames';
import React from 'react';
import { Heading } from '@mm/components';
import { CreateCampaignButton } from '../CreateCampaignButton/CreateCampaignButton';
import { campaignTypeByKind, UIFilterCampaignKindType } from '../types';
import './CampaignsEmptyState.pcss';

type Props = {
  className?: string;
  kind?: UIFilterCampaignKindType;
};

// TODO MM-3556 impr: make create button standalone for all entity types
export const CampaignsEmptyState = ({ className, kind }: Props) => {
  const starter = kind
    ? campaignTypeByKind[kind]
    : { name: 'Campaigns', icon: AllIcon };
  const { name, icon: Icon } = starter;
  return (
    <div className={classNames(className, 'campaigns-empty-state')}>
      <div className="campaigns-empty-state__icon-container">
        <Icon className="campaigns-empty-state__icon" color="#e7e7e9" />
      </div>
      <Heading
        size={6}
        className="campaigns-empty-state__text"
        text={`You do not have ${name} created yet`}
      />
      <CreateCampaignButton kind={kind} withPlusIcon />
    </div>
  );
};
